import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgProgress } from 'ngx-progressbar';
import { LogisticsService } from '../shared/logistics.service';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import * as firebase from 'firebase/app';
import { formatDate } from '@telerik/kendo-intl';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
export const form_date = {
  from : "",
  to: ""
};
export const search_id = {
  id: ""
};
@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.css'],
  providers: [NotificationToastService, LogisticsService]
})
export class FinanceComponent implements OnInit {
  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public originalData: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public skip1 = 0;
  public pageSize = 10;
  total:Number;
  currency:String;
  myForm: FormGroup;
  myFormMonth: FormGroup;
  myFormSelect:FormGroup;
  shipments:any;
  years:any;
  months:any;
  customerName: string = "";
  date = new Date();
  formatDate = formatDate(this.date, "yyyy/MM/dd");
  splitDate = this.formatDate.split('/');
  a: string;
  b: string;
  c: string
  @ViewChild('popUpModal') popUpModal;
  assignedHistoryList: any;
  cchList: any[];
  
  get sum() {
    return this.a +'-'+ this.b+'-'+this.c;
  }
  constructor(private router: Router, private config: NgbDatepickerConfig, private nf:NotificationToastService, private ngProgress: NgProgress, private logisticsService: LogisticsService) {
      this.initializeForms();
      config.minDate = {year:1890, month:1, day: 1};
      config.maxDate = {year: 2099, month: 12, day: 31};
      config.outsideDays = 'visible';
   }

  ngOnInit() {
    this.shipments = this.logisticsService.getShipments();
    this.checkSearchId();
    this.getYearsList();
    this.getMonthsList();
    this.getSettings();
    this.myFormSelect =  new FormGroup({
      selectFilter : new FormControl('1', Validators.required)
    });
    if(form_date.from != "")
   {
     //console.log("date is ", form_date);
      this.getSpecificDateShipment(form_date.from, form_date.to);
      this.myForm = new FormGroup({
        fromdate: new FormControl(form_date.from, Validators.required),
        todate: new FormControl(form_date.to)
    });
    this.myFormSelect.reset();
   }
   else{
    this.getTodaysShipments();
   }
   this.myFormSelect.get('selectFilter').setValue('2');
   this.onFilterSelected("2");
   this.myFormMonth.get('year').setValue(this.splitDate[0]);
   this.myFormMonth.get('month').setValue(this.splitDate[1].substring(0, 1)==="0" ? this.splitDate[1].substring(1,2 ) : this.splitDate[1]);

   this.onSubmitByMonth();
  }
  initializeForms()
  {
    //by date
    let fromdate = new FormControl('', Validators.required);
    let todate = new FormControl('');
      this.myForm = new FormGroup({
        fromdate: fromdate,
        todate: todate
      });
    //by month
    let year = new FormControl('', Validators.required);
    let month = new FormControl('');
      this.myFormMonth = new FormGroup({
        year: year,
        month: month
      });
      this.myFormMonth.reset();
  }
  getYearsList()
  {
    this.years = [];
    for(let i=0;i<5;i++)
    {
      var y = 2018 + i;
      this.years.push(y);
    }
  }
  getMonthsList()
  {
    this.months = [
      {
        index: 1,
        month: "January"
      },
      {
        index: 2,
        month: "February"
      },
      {
        index: 3,
        month: "March"
      },
      {
        index: 4,
        month: "April"
      },
      {
        index: 5,
        month: "May"
      },
      {
        index: 6,
        month: "June"
      },
      {
        index: 7,
        month: "July"
      },
      {
        index: 8,
        month: "August"
      },
      {
        index: 9,
        month: "September"
      },
      {
        index: 10,
        month: "October"
      },
      {
        index: 11,
        month: "November"
      },
      {
        index: 12,
        month: "December"
      }
    ];

  }
  getTodaysShipments()
  {
    var date = new Date();
    var today = date.getDate()+"/"+(date.getMonth() + 1)+"/"+date.getFullYear();
    this.shipments.snapshotChanges().subscribe(item=>{
    this.ngProgress.start();
      this.data = [];
      this.originalData = [];
      this.total = 0;
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          var shipment_date1 = element.payload.child("source").child("date").child("day").val()+"/"+element.payload.child("source").child("date").child("month").val()+"/"+element.payload.child("source").child("date").child("year").val();
          var shipment_date2 = element.payload.child("destination").child("date").child("day").val()+"/"+element.payload.child("destination").child("date").child("month").val()+"/"+element.payload.child("destination").child("date").child("year").val();
          if(today == shipment_date1 || today == shipment_date2)
          {
            if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() !=0  && element.payload.child("cashCollected").val() != null)
            {
              this.data.push(y);
              this.originalData.push(y);
              this.total = this.total + element.payload.child("cashCollected").val();
            }
          }
      });
      this.ngProgress.done();
      this.loadItemSearchResult();
    });
  }
  onSubmit()
  {
    this.ngProgress.start();
    this.addToast();
    var from = this.myForm.value.fromdate;
    var to = this.myForm.value.todate;
    form_date.from = from;
    form_date.to = to;
    this.getSpecificDateShipment(from,to);
  }
  getSpecificDateShipment(from,to)
  {
    this.shipments.snapshotChanges().subscribe(item=>{
      this.ngProgress.start();
      this.data = [];
      this.originalData = [];
      this.total = 0;
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          var fromDate = new Date(from.year+"/"+from.month+"/"+from.day);
          var toDate;
          if(to == '')
          {
            var date = new Date();
            toDate  = new Date(date.getFullYear()+"/"+(date.getMonth() + 1)+"/"+date.getDate());
          }
          else
          {
            toDate  = new Date(to.year+"/"+to.month+"/"+to.day);
          }
          while(fromDate <= toDate)
          {
          var currentDate = fromDate.getDate()+"/"+(fromDate.getMonth()+1) +"/"+fromDate.getFullYear();
          var shipment_date = element.payload.child("source").child("date").child("day").val()+"/"+element.payload.child("source").child("date").child("month").val()+"/"+element.payload.child("source").child("date").child("year").val();
          var shipment_date2 = element.payload.child("destination").child("date").child("day").val()+"/"+element.payload.child("destination").child("date").child("month").val()+"/"+element.payload.child("destination").child("date").child("year").val();
          if(currentDate == shipment_date || currentDate == shipment_date2)
            {
              //console.log("currentDate",currentDate);
              if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0)
              {
                //console.log("inside cashCollected");
                if(!(this.data.includes(y)))
                {
                  this.data.push(y);
                  this.originalData.push(y);
                  this.total = this.total + element.payload.child("cashCollected").val();
                }
                //console.log("cashCollected  total",element.payload.child("cashCollected").val(), this.total, element.key);
              }
            }
            fromDate.setDate(fromDate.getDate() + 1);
          }
        });
    this.ngProgress.done();
    this.loadItemSearchResult();
    });
  }
  checkSearchId()
  {
    if(search_id.id != "")
    {
      this.filterQuery = search_id.id;
    }
  }
  view(id)
  {
    search_id.id = this.filterQuery;
    this.router.navigate(['/view-shipment-details'], { queryParams : {key: id, from: 'finance'}  });
  }
  refresh()
    {
      this.sortBy = "";
      this.filterQuery = "";
      this.getTodaysShipments();
      this.myForm.reset();
      form_date.from = "";
      form_date.to = "";
      this.myFormMonth.reset();
      this.myFormSelect.reset();
      this.myFormSelect.setControl("selectFilter",new FormControl("1"));
      this.byDate = true;
      this.byMonth = false;
      this.last6Months = false;
      this.customerName = ""; 
    }
  addToast()
  {
    this.nf.addToast({title:'Loading', msg:'Please wait while data is being fetched from the server', showClose: true, timeout: 500, theme:'bootstrap', type:'wait', position:'top-left', closeOther:true}
  )
  }
  invoice(id)
     {
       //window.open("http://paarseldev.com/invoice/"+id, '_blank');
      window.open("http://paarsel.com/invoice/"+id, '_blank');
     }
     getSettings()
     {
      firebase.database().ref("settings").child("general").on("value",(generalSetting)=>{
        this.currency =  generalSetting.child('currency').val();
      });
     }
     getSelectedFilter(e)
     {
      var filter = e.target.value;
      var date = new Date();
      this.shipments.snapshotChanges().subscribe((snapshot)=>{
        this.data = [];
        this.originalData = [];
        this.total = 0;
        if(filter == "day")
        {
          snapshot.forEach((element)=>{
            var source = element.payload.child("source/date/day").val() == date.getDate() && element.payload.child("source/date/month").val() == (date.getMonth() + 1) && element.payload.child("source/date/year").val() == date.getFullYear();
            var destination = element.payload.child("destination/date/day").val() == date.getDate() && element.payload.child("destination/date/month").val() == (date.getMonth() + 1) && element.payload.child("destination/date/year").val() == date.getFullYear();
            if(source || destination)
            {
              if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0  && element.payload.child("cashCollected").val() != null)
              {
                var y = element.payload.toJSON();
                y["$key"] = element.key;
                this.data.push(y);
                this.originalData.push(y);
                this.total =  this.total + element.payload.child("cashCollected").val();
              }
            }
          });
        }
        else if(filter == "month")
        {
          snapshot.forEach((element)=>{
            var source = element.payload.child("source/date/month").val() == (date.getMonth() + 1) && element.payload.child("source/date/year").val() == date.getFullYear();
            var destination = element.payload.child("destination/date/month").val() == (date.getMonth() + 1) && element.payload.child("destination/date/year").val() == date.getFullYear();
            if(source || destination)
            {
              if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0  && element.payload.child("cashCollected").val() != null)
              {
                var y = element.payload.toJSON();
                y["$key"] = element.key;
                this.data.push(y);
                this.originalData.push(y);
                this.total =  this.total + element.payload.child("cashCollected").val();
              }
            }
          });
        }
        else
        {
          snapshot.forEach((element)=>{
            var source = element.payload.child("source/date/year").val() == date.getFullYear();
            var destination = element.payload.child("destination/date/year").val() == date.getFullYear();
            if(source || destination)
            {
              if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0  && element.payload.child("cashCollected").val() != null)
              {
                var y = element.payload.toJSON();
                y["$key"] = element.key;
                this.data.push(y);
                this.originalData.push(y);
                this.total =  this.total + element.payload.child("cashCollected").val();
              }
            }
          });
        }
        this.loadItemSearchResult();

      });
     }
     byDate:boolean = true;
     byMonth:boolean = false;
     last6Months:boolean = false;
     onFilterSelected(event)
     {
      this.byDate = false;
      this.byMonth = false;
      this.last6Months = false;
      if(event==="2") {
        this.byMonth = true;
      } else {
        switch(event.target.value)
        {
          case "1":
          this.byDate = true;
          break;
          case "2":
          this.byMonth = true;
          break;
          case "3":
          this.last6Months = true;
          break;
        }
      }
     }
     onSubmitByMonth()
     {
        var year = this.myFormMonth.value.year;
         var month = this.myFormMonth.value.month;
         //console.log(Number(year),Number(month));
        this.shipments.snapshotChanges().subscribe((snapshot)=>{
          this.data = [];
          this.originalData = [];
          this.total = 0;
          if(Number(year) > 0  && Number(month) > 0)
          {
            snapshot.forEach((element)=>{
              if(Number(year) == element.payload.child("source/date/year").val() && Number(month) == element.payload.child("source/date/month").val())
              {
                if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0  && element.payload.child("cashCollected").val() != null)
                {
                  var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  this.data.push(y);
                  this.originalData.push(y);
                  this.total =  this.total + element.payload.child("cashCollected").val();
                }
                else if(Number(year) == element.payload.child("destination/date/year").val() && Number(month) == element.payload.child("destination/date/month").val())
                {
                  if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0  && element.payload.child("cashCollected").val() != null)
                  {
                    var y = element.payload.toJSON();
                      y["$key"] = element.key;
                      this.data.push(y);
                      this.originalData.push(y);
                  }
                }
              }
            });
          }
          else if(Number(month) == 0)
          {
            snapshot.forEach((element)=>{
              if(Number(year) == element.payload.child("source/date/year").val() || Number(year) == element.payload.child("destination/date/year").val())
              {
                if(element.payload.child("cashCollected").exists() && element.payload.child("cashCollected").val() >0  && element.payload.child("cashCollected").val() != null)
                {
                  var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  this.data.push(y);
                  this.originalData.push(y);
                  this.total =  this.total + element.payload.child("cashCollected").val();
                }
              }
            });
          }
          this.loadItemSearchResult();
        });
      }
      onSearchChange(searchValue : string ) {  
        //console.log(searchValue);
        this.shipments.snapshotChanges().subscribe((snapshot)=>{
          this.data = [];
          this.originalData = [];
          this.total = 0;
          snapshot.forEach((element)=>{
            var id = String(element.payload.child("id").val());
            var amount = String(element.payload.child("cashCollected").val());
            var sourceName = element.payload.child("source/name").val()!==null ? element.payload.child("source/name").val().toLowerCase() : '';
            var destinationName = element.payload.child("destination/name").val()!==null ? element.payload.child("destination/name").val().toLowerCase() : '';
            var sourceAddrress = element.payload.child("source/addressLine1").val()!==null ? element.payload.child("source/addressLine1").val().toLowerCase() : '';
            var sourceCity = element.payload.child("source/city").val()!==null ? element.payload.child("source/city").val().toLowerCase() : '';
            var sourcePhoneNumber = element.payload.child("source/phoneNumber").val()!==null ? element.payload.child("source/phoneNumber").val().toLowerCase() : '';
            var destinationAddrress = element.payload.child("destination/addressLine1").val()!==null ? element.payload.child("destination/addressLine1").val().toLowerCase() : '';
            console.log('da==> '+ element.payload.child("destination/addressLine1").val());
            var destinationCity = element.payload.child("destination/city").val()!==null ? element.payload.child("destination/city").val().toLowerCase() : '';
            var destinationPhoneNumber = element.payload.child("destination/phoneNumber")!==null ? element.payload.child("destination/phoneNumber").val().toLowerCase() : '';
            if(sourceName.includes(searchValue.toLowerCase()) || destinationName.includes(searchValue.toLowerCase())
            || sourceAddrress.includes(searchValue.toLowerCase()) || destinationAddrress.includes(searchValue.toLowerCase())
            || sourceCity.includes(searchValue.toLowerCase()) || destinationCity.includes(searchValue.toLowerCase())
            || sourcePhoneNumber.includes(searchValue.toLowerCase()) || destinationPhoneNumber.includes(searchValue.toLowerCase())
            || id.includes(searchValue) || amount.includes(searchValue))
            {
              //console.log("includes");
              var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  this.data.push(y);
                  this.originalData.push(y);
                  this.total =  this.total + element.payload.child("cashCollected").val();
            }
          });
          this.loadItemSearchResult();
        });
        }

  loadItemSearchResult() {
  
      this.data = {
        data: this.originalData.slice(this.skip1, this.skip1 + this.pageSize),
        total: this.originalData.length
      };

  }
public pageChange(event: PageChangeEvent): void {
  this.skip1 = event.skip;
  this.loadItemSearchResult();
}

  cch(cch, assignedHistory) {
    this.assignedHistoryList = [];
    this.cchList = [];
    var cchListKeys = Object.keys(cch);
    var assignedHistoryKeys = Object.keys(assignedHistory);

    for (var i = 0; i < cchListKeys.length; i++) {
      this.cchList.push(cch[cchListKeys[i]]);
      for (var j = 0; j < assignedHistoryKeys.length; j++) {
        if(cch[cchListKeys[i]].userId === assignedHistory[assignedHistoryKeys[j]].assignedTo)
        this.cchList[i].role = assignedHistory[assignedHistoryKeys[j]].role;
      }
    }
    this.popUpModal.show();
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/finance/finance.component.ts